import { carouselItems } from "../data/carouselData";
import "./carousel.css"

export function Carousel({ items = [] }) {
  return (
    <div className="carousel-wrapper">
      <div className="carousel">
        {items.map((item, i) => (
          <a key={i} href={item.link} className="card">
            <img src={item.image} alt="post" />
            <p>{item.text}</p>
          </a>
        ))}
      </div>
    </div>
  );
}